<template>
  <div
    class="currentInvestedFund-cards"
    v-if="!loading && currentInvestedFunds.length > 0"
  >
    <SectionTitle :text="$t('home.myFunds.title')" />
    <div class="fund-cards-grid">
      <div
        v-for="currentInvestedFund in currentInvestedFunds"
        :key="currentInvestedFund.id"
        @click="
          $router.push({
            name: 'detailedFund',
            params: { fundRun: currentInvestedFund.fundRun },
          })
        "
      >
        <FundCard :fundBalance="currentInvestedFund" class="clickable-item" />
      </div>
    </div>
  </div>
  <v-row v-else-if="loading" class="mt-10">
    <v-col cols="12" sm="6" md="4" lg="3" v-for="n in 8" :key="n.index">
      <v-skeleton-loader type="list-item-two-line" />
    </v-col>
  </v-row>
</template>

<script>
import { mapGetters } from "vuex";
import FundCard from "@/components/shared/FundCard.vue";
import SectionTitle from "@/components/home/SectionTitle.vue";

export default {
  name: "FundCards",

  components: {
    FundCard,
    SectionTitle,
  },

  computed: {
    ...mapGetters(["loading", "currentInvestedFunds"]),
  },
};
</script>

<style lang="scss" scoped>
.fund-cards-grid {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 10px;

  @media (max-width: 1500px) {
    grid-template-columns: repeat(3, 1fr);
  }
  @media (max-width: 960px) {
    grid-template-columns: repeat(2, 1fr);
    margin: 0 20px;
  }
  @media (max-width: 600px) {
    grid-template-columns: repeat(1, 1fr);
  }
}
</style>
